import React, { useEffect } from 'react';

/**
 * Component to monitor and debug state changes
 */
const DebugMonitor = ({ 
  showClues, 
  currentQuestionId,
  enabled = false  // Only show debug info if enabled
}) => {
  useEffect(() => {
    if (!enabled) return;
    // console.log(`[DebugMonitor] State Update - showClues: ${showClues}, questionId: ${currentQuestionId}`);
  }, [showClues, currentQuestionId, enabled]);

  if (!enabled) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: '10px',
      right: '10px',
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      color: '#fff',
      padding: '8px 12px',
      borderRadius: '4px',
      fontSize: '12px',
      zIndex: 1000,
      fontFamily: 'monospace'
    }}>
      <div>
        <strong>Debug:</strong> 
        {' '}QID: {currentQuestionId || 'none'}
        {' '}Clues: {showClues ? 'ON' : 'OFF'}
      </div>
    </div>
  );
};

export default DebugMonitor;
